module.exports = __webpack_public_path__ + "static/media/one_investment_account.597bebe0.svg";